<template>
  <v-form ref="p1Form" v-model="p1Form" lazy-validation>
    <v-container>
      <v-card class="gridlist">
        <v-card-text>
          <v-row>
            <v-col>
              <!-- 2024.11.29 kouta.noborisaka 三井化学（市原工場）:絞り込みでEnterキー入力時にサブミット実行しないように「@submit.prevent」を追加 -->
              <v-form
                ref="tableForm"
                v-model="tableForm"
                lazy-validation
                @submit.prevent
              >
                <ryou-table
                  ref="ryouTable"
                  :rowKey="rowKey"
                  :headers="headers"
                  :queryParams="queryParam"
                  :url="url"
                  :businessKey="businessKey"
                  :dummy="false"
                  :needSearch="true"
                  :height="height"
                  :handleEdit="handleEdit"
                  :handleDelete="handleDelete"
                  :title="'会社一覧'"
                >
                  <v-row slot="filterContainer">
                    <v-col cols="8"></v-col>
                    <v-col cols="2" class="addBtn">
                      <ryou-blue-btn
                        :label="'新規追加'"
                        :handlerClick="handleAdd"
                      ></ryou-blue-btn>
                    </v-col>
                  </v-row>
                </ryou-table>
              </v-form>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <master-p1-dialog
        ref="modalForm"
        @ok="modalFormOk"
        :url="url"
      ></master-p1-dialog>
      <ryou-confirm ref="confirm"></ryou-confirm>
    </v-container>
  </v-form>
</template>

<script>
import RyouBlueBtn from "@/components/formInput/RyouBlueBtn.vue";
import RyouTable from "@/components/table/RyouTable.vue";
import MasterP1Dialog from "./modules/MasterP1Dialog2.vue";
import RyouConfirm from "@/components/dialog/RyouConfirm.vue";
import { RyouTableMixins } from "@/mixins/RyouTableMixins";

export default {
  name: "MasterCompany",
  mixins: [RyouTableMixins],
  components: {
    RyouBlueBtn,
    RyouTable,
    MasterP1Dialog,
    RyouConfirm,
  },
  mounted() {},
  data() {
    return {
      p1Form: true,
      search: "",
      rowKey: "rowIndex",
      businessKey: "companyId",
      tableForm: true,
      headers: [
        {
          text: "No",
          value: "companyId",
          class: "blue lighten-2 title",
          width: "10%",
          sortable: true,
          groupable: false,
        },
        {
          text: "会社名",
          value: "companyName",
          class: "blue lighten-2 title",
          width: "20%",
          sortable: true,
          groupable: false,
        },
        {
          text: "会社略称",
          value: "companyCode",
          class: "blue lighten-2 title",
          width: "20%",
          type: "text",
          sortable: true,
          groupable: false,
        },
        {
          text: "操作",
          class: "blue lighten-2 title",
          value: "actions",
          align: "center",
          sortable: false,
          groupable: false,
        },
      ],
      height: 700,
      types: ["success", "error", "warning", "info", "default"],
      url: {
        list: "/company/get",
        delete: "/company/delete",
        add: "company/insert",
        update: "/company/update",
        deleteBatch: "/company/deleteBatch",
      },
    };
  },
  methods: {},
};
</script>

<style></style>
